module.exports = __webpack_public_path__ + "media/flags/cc-bc89abfd.svg";